import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons';
import { Section, SectionTitle, Row, Column, Label, ControlLabel } from '../../../styles/WidgetCustomizer.styles';
import { StyledSwitch, Input } from '../../../styles/WidgetCustomizer.styles';

const SettingsTab = ({
    urls,
    setUrls,
    deviceVisibility,
    setDeviceVisibility,
    showHelp,
    error,
    settings,
    setSettings
}) => {
    return (
        <>
            <Section>
                <SectionTitle>Stream Settings</SectionTitle>
                {error && (
                    <Row>
                        <Column>
                            <div style={{ color: 'red', fontSize: '0.875rem', marginBottom: '1rem' }}>
                                {error}
                            </div>
                        </Column>
                    </Row>
                )}

                <Row>
                    <Column>
                        <Label>
                            Stream URL
                            <FontAwesomeIcon
                                icon={faQuestionCircle}
                                onClick={() => showHelp(
                                    'Stream URL',
                                    'The URL of your radio stream. This is automatically configured based on your station ID, but you can modify it if needed.'
                                )}
                                style={{ cursor: 'pointer', marginLeft: '0.5rem' }}
                            />
                        </Label>
                        <Input
                            type="text"
                            value={urls.streamUrl}
                            onChange={(e) => setUrls(prev => ({ ...prev, streamUrl: e.target.value }))}
                            placeholder="https://..."
                        />
                    </Column>
                </Row>

                <Row>
                    <Column>
                        <Label>
                            API URL
                            <FontAwesomeIcon
                                icon={faQuestionCircle}
                                onClick={() => showHelp(
                                    'API URL',
                                    'The URL of your radio API endpoint. This is automatically configured based on your station ID, but you can modify it if needed.'
                                )}
                                style={{ cursor: 'pointer', marginLeft: '0.5rem' }}
                            />
                        </Label>
                        <Input
                            type="text"
                            value={urls.apiUrl}
                            onChange={(e) => setUrls(prev => ({ ...prev, apiUrl: e.target.value }))}
                            placeholder="https://..."
                        />
                    </Column>
                </Row>
            </Section>

            <Section>
                <SectionTitle>Device Visibility</SectionTitle>
                <Row style={{ gap: '2rem' }}>
                    <Column style={{ flex: 1 }}>
                        <ControlLabel>
                            Hide on mobile
                            <StyledSwitch
                                checked={deviceVisibility.mobile}
                                onChange={(checked) => setDeviceVisibility(prev => ({ ...prev, mobile: checked }))}
                                height={24}
                                width={44}
                                handleDiameter={20}
                                uncheckedIcon={false}
                                checkedIcon={false}
                                offColor="#e0e0e0"
                                onColor="#4AE66E"
                                boxShadow="none"
                            />
                        </ControlLabel>
                    </Column>
                    <Column style={{ flex: 1 }}>
                        <ControlLabel>
                            Hide on desktop
                            <StyledSwitch
                                checked={deviceVisibility.desktop}
                                onChange={(checked) => setDeviceVisibility(prev => ({ ...prev, desktop: checked }))}
                                height={24}
                                width={44}
                                handleDiameter={20}
                                uncheckedIcon={false}
                                checkedIcon={false}
                                offColor="#e0e0e0"
                                onColor="#4AE66E"
                                boxShadow="none"
                            />
                        </ControlLabel>
                    </Column>
                </Row>
                <Row style={{ gap: '2rem' }}>
                    <Column style={{ flex: 1 }}>
                        <ControlLabel>
                            Hide on tablet
                            <StyledSwitch
                                checked={deviceVisibility.tablet}
                                onChange={(checked) => setDeviceVisibility(prev => ({ ...prev, tablet: checked }))}
                                height={24}
                                width={44}
                                handleDiameter={20}
                                uncheckedIcon={false}
                                checkedIcon={false}
                                offColor="#e0e0e0"
                                onColor="#4AE66E"
                                boxShadow="none"
                            />
                        </ControlLabel>
                    </Column>
                    <Column style={{ flex: 1 }}>
                    </Column>
                </Row>
            </Section>

            <Section>
                <SectionTitle>Song History Settings</SectionTitle>
                <Row>
                    <Column>
                        <Label>Song history modal header</Label>
                        <Input
                            type="text"
                            value={settings.historyHeaderText || 'Song History'}
                            onChange={(e) => setSettings(prev => ({ ...prev, historyHeaderText: e.target.value }))}
                            placeholder="Enter header text"
                        />
                    </Column>
                </Row>
            </Section>
        </>
    );
}

export default SettingsTab; 